// A stable hue per person or candidate, from their id (never random, never from the name's position in a list). People
// wear the six --p-* accents (initials in a hue ring); candidates wear a tint tile (--t-*). Pass the result through
// vars({"--mc-hue": personHue(id)}) or vars({"--mc-hue-bg": candidateHue(id)}).

export const PERSON_HUES = ["var(--p-blue)", "var(--p-purple)", "var(--p-gold)", "var(--p-green)", "var(--p-orange)", "var(--p-grey)"] as const;
export const CANDIDATE_HUES = ["var(--t-purple)", "var(--t-blue)", "var(--t-green)", "var(--t-orange)", "var(--t-gold)", "var(--t-red)"] as const;

export type PersonHue = (typeof PERSON_HUES)[number];
export type CandidateHue = (typeof CANDIDATE_HUES)[number];

/** 32-bit FNV-1a over the UTF-16 code units. */
export function hashKey(key: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < key.length; i++) {
    hash ^= key.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

export function personHue(id: string): PersonHue {
  return PERSON_HUES[hashKey(id) % PERSON_HUES.length] ?? PERSON_HUES[0];
}

export function candidateHue(id: string): CandidateHue {
  return CANDIDATE_HUES[hashKey(id) % CANDIDATE_HUES.length] ?? CANDIDATE_HUES[0];
}
